import React, { Fragment } from 'react'
import { graphql } from 'gatsby'
import SVG from 'react-inlinesvg'
import { navigate } from 'gatsby'

import InlineSVG from 'react-inlinesvg'
import { redirectTo } from '@reach/router'
import Media from 'react-media'
import { getTagColour, parseMachineNavigationData } from '../utils/selectors'
import { window } from 'browser-monads'
import Layout from '../layouts/layout'

import { InnerContainer, Tags } from '../components/article-card/styles'

import {
  Container,
  Title,
  Content,
  HeroImage,
  HeroImageContainer,
  MachineContainer,
  SocialLinks,
  SocialLink,
  Label,
  BackButton,
  Subheading,
} from '../styles/article'
import DynamicContentContainer from '../utils/dynamicContentContainer'
// import SubscribeForm from '../components/subscribe-form/subscribeForm'
import MachineLink from '../components/machine-link/index'

class Article extends React.Component {
  render = () => {
    const location = typeof window !== 'undefined' ? window.location : ''
    const article = this.props.data.prismicArticle.data
    const contentComponents =
      article && article.body && article.body.length > 0
        ? article.body[0].items
        : []
    const machine =
      article &&
      article.machine &&
      article.machine.document &&
      article.machine.document.length > 0
        ? article.machine.document[0].data
        : undefined
    const title = article.title.text
    const subHeading = article.subheading.text
    const headingImage = article.heading_image.url
    const desktopImage = article.desktop_image.url
    const pdf = article.pdf_download ? article.pdf_download.url : undefined
    const shareContent = `${title} - $location}`

    const twitter = `https://twitter.com/home?status=${shareContent}`
    const facebook = `https://www.facebook.com/sharer/sharer.php?u=${shareContent}`
    const linkedin = `https://www.linkedin.com/shareArticle?mini=true&url=${location}&title=${title}&summary=&source=`
    const classes = machine ? 'hasMachine' : ''

    return (
      <Layout isWhite customClassName={classes}>
        <Container>
          <BackButton
            onClick={() => {
              navigate('/news')
            }}
            className="arrow"
          >
            <SVG src="/images/article/arrow.svg" />
          </BackButton>
          <Tags
            style={{
              marginTop: '-20px',
              marginBottom: '30px',
              display: 'inline-block',
              position: 'relative',
            }}
            color={getTagColour(article.tags)}
          >
            {article.tags}
          </Tags>
          <Title>{title}</Title>
          {subHeading && <Subheading>{subHeading}</Subheading>}
          <HeroImageContainer className="heroImageContainer">
            <Fragment>
              <Media
                query="(min-width:768px)"
                render={() => <HeroImage src={desktopImage} />}
              />
            </Fragment>
            <Fragment>
              <Media
                query="(max-width:767px)"
                render={() => <HeroImage src={headingImage} />}
              />
            </Fragment>
          </HeroImageContainer>
          <SocialLinks className="socialLinks">
            <SocialLink href={twitter}>
              <SVG src="/images/article/Twitter.svg" />
            </SocialLink>
            <SocialLink href={facebook}>
              <SVG src="/images/article/Facebook.svg" />
            </SocialLink>
            <SocialLink href={linkedin}>
              <SVG src="/images/article/linkedin.svg" />
            </SocialLink>
            {pdf && (
              <SocialLink
                target="_blank"
                href={pdf}
                style={{ width: '39px', marginLeft: '5px' }}
              >
                <SVG src="/images/download.svg" />
              </SocialLink>
            )}
          </SocialLinks>
          {machine && (
            <MachineContainer className="machineContainer">
              {article.machine_tagline && article.machine_tagline.text && (
                <Label>{article.machine_tagline.text}</Label>
              )}
              <MachineLink machine={machine} />
            </MachineContainer>
          )}
          <Content>
            <DynamicContentContainer
              name={this.constructor.displayName}
              data={contentComponents}
            />
          </Content>
        </Container>
        {/* <SubscribeForm /> */}
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query GetArticle($uid: String!) {
    prismicArticle(uid: { eq: $uid }) {
      ...Article
    }
  }
`

export default Article
